import { render } from "./NidReport.vue?vue&type=template&id=41ae5c63&ts=true"
import script from "./NidReport.vue?vue&type=script&lang=ts"
export * from "./NidReport.vue?vue&type=script&lang=ts"

import "./NidReport.vue?vue&type=style&index=0&id=41ae5c63&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__